/*eslint no-sequences: "off"*/
/*eslint no-empty-pattern: "off"*/

import { createSlice } from '@reduxjs/toolkit';
import { Ikpi } from './interfaces';
import { initState } from './init.state';

import {
  SetEnergyKpiDataCommunityAsync,
  SetEconomicsKpiDataCommunityAsync,
  SetEnergyKpiDataCommunityRankingAsync,
  SetEconomicsKpiDataCommunityRankingAsync,
  SetEnergyKpiDataSiteAsync,
  SetEconomicsKpiDataSiteAsync,
  SetEnergyKpiDataMemberAsync,
  SetEconomicsKpiDataMemberAsync,
  SetEnergyKpiDataMemberRankingAsync,
  SetEconomicsKpiDataMemberRankingAsync,
  SetAncillaryKpiDataSiteAsync,
  SetAncillaryKpiDataMemberAsync,
  SetAncillaryKpiDataCommunityAsync,
  SetComparisonKpiDataCommunityAsync,
  SetEconomicsCustomKpiDataMemberAsync,
  SetEnergyCustomKpiDataMemberAsync,
  SetEnergyCustomKpiDataCommunityAsync,
  SetEconomicsCustomKpiDataCommunityAsync,
  SetEconomicsCustomKpiDataSiteAsync,
  SetEnergyCustomKpiDataSiteAsync
} from './async-thunks';

export const KPIslice = createSlice({
  name: 'kpi',
  initialState: initState,
  reducers: {
    SetKpiDataCommunity: (state: Ikpi, action: any) => {
      return {
        ...state,
        community: action?.payload || null
      };
    },
    SetKpiDataCommunityRanking: (state: Ikpi, action: any) => {
      return {
        ...state,
        communityRanking: {
          ...(state?.communityRanking || {}),
          ...action.payload,
        },
      };
    },
    SetKpiDataMemberRanking: (state: Ikpi, action: any) => {
      return {
        ...state,
        memberRanking: {
          ...(state?.memberRanking || {}),
          ...action.payload,
        },
      };
    },
    SetKpiDataSite: (state: Ikpi, action: any) => {
      return {
        ...state,
        site: action?.payload || null,
      };
    },
    SetKpiDataMember: (state: Ikpi, action: any) => {
      return {
        ...state,
        member: action?.payload || null,
      };
    },
    SetKwickInvoices: (state: Ikpi, action: any) => {
      return {
        ...state,
        kwickInvoices: action?.payload[0] || null,
        kwickOverview: action?.payload[1] || null,
      };
    },
    ResetKpiApiStore: () => {
      return initState;
    },
    SetKpiDataCustom: (state: Ikpi, action: any) => {
      // Aggiungi la logica per questa funzione personalizzata, se necessario
      return {
        ...state,
        customData: action.payload, // Esempio, sostituire con il tuo campo reale
      };
    },
    SetLoading: (state: Ikpi, action: any) => {
      return {
        ...state,
        isLoading: action.payload,
      };

    },

    ResetKpiFields: (state: Ikpi) => {
      return {
        ...state,
        community: null,
        member: null,
        communityRanking: null,
        memberRanking: null,
        site: null,
      } as any
    },

    ResetNamedKpiFields: (state: Ikpi, action: any) => {
      return {
        ...state,
        [action.payload]: null,
      } as any
    }
  },
  extraReducers: (builder) => {


    // ########### COMMUNITY DATA ########### 
    // ########### ENERGY ########### 
    builder.addCase(SetEnergyKpiDataCommunityAsync.pending, (_state, _action) => ({
      ..._state,
      EnergyKpiDataCommunityAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetEnergyKpiDataCommunityAsync.rejected, (_state, _action) => ({
      ..._state,
      EnergyKpiDataCommunityAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetEnergyKpiDataCommunityAsync.fulfilled, (_state, action) => ({
      ..._state,
      EnergyCommunity: action.payload,
      EnergyKpiDataCommunityAsyncStatus: 'SUCCESS',
    }));


    builder.addCase(SetEnergyKpiDataCommunityRankingAsync.pending, (_state, _action) => ({
      ..._state,
      EnergyKpiDataCommunityRankingAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetEnergyKpiDataCommunityRankingAsync.rejected, (_state, _action) => ({
      ..._state,
      EnergyKpiDataCommunityRankingAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetEnergyKpiDataCommunityRankingAsync.fulfilled, (_state, action) => ({
      ..._state,
      communityRanking: {
        ...(_state?.communityRanking || {}),
        ...action.payload,
      },
      EnergyKpiDataCommunityRankingAsyncStatus: 'SUCCESS',
    }));

    builder.addCase(SetEnergyCustomKpiDataCommunityAsync.pending, (_state, _action) => ({
      ..._state,
      EnergyCustomKpiDataCommunityAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetEnergyCustomKpiDataCommunityAsync.rejected, (_state, _action) => ({
      ..._state,
      EnergyCustomKpiDataCommunityAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetEnergyCustomKpiDataCommunityAsync.fulfilled, (_state, action) => ({
      ..._state,
      EnergyCustomKpiCommunity: action.payload as any,
      EnergyCustomKpiDataCommunityAsyncStatus: 'SUCCESS',
    }));

    // ########### ECONOMICS ########### 
    builder.addCase(SetEconomicsKpiDataCommunityAsync.pending, (_state, _action) => ({
      ..._state,
      EconomicsKpiDataCommunityAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetEconomicsKpiDataCommunityAsync.rejected, (_state, _action) => ({
      ..._state,
      EconomicsKpiDataCommunityAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetEconomicsKpiDataCommunityAsync.fulfilled, (_state, action) => ({
      ..._state,
      EconomicsCommunity: action.payload,
      EconomicsKpiDataCommunityAsyncStatus: 'SUCCESS',
    }));

    builder.addCase(SetEconomicsKpiDataCommunityRankingAsync.pending, (_state, _action) => ({
      ..._state,
      EconomicsKpiDataCommunityRankingAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetEconomicsKpiDataCommunityRankingAsync.rejected, (_state, _action) => ({
      ..._state,
      EconomicsKpiDataCommunityRankingAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetEconomicsKpiDataCommunityRankingAsync.fulfilled, (_state, action) => ({
      ..._state,
      communityRanking: {
        ...(_state?.communityRanking || {}),
        ...action.payload,
      },
      EconomicsKpiDataCommunityRankingAsyncStatus: 'SUCCESS',
    }));

    builder.addCase(SetEconomicsCustomKpiDataCommunityAsync.pending, (_state, _action) => ({
      ..._state,
      EconomicsCustomKpiDataCommunityAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetEconomicsCustomKpiDataCommunityAsync.rejected, (_state, _action) => ({
      ..._state,
      EconomicsCustomKpiDataCommunityAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetEconomicsCustomKpiDataCommunityAsync.fulfilled, (_state, action) => ({
      ..._state,
      EconomicsCustomKpiCommunity: action.payload as any,
      EconomicsCustomKpiDataCommunityAsyncStatus: 'SUCCESS',
    }));



    // ########### ANCILLARY ########### 
    builder.addCase(SetAncillaryKpiDataCommunityAsync.pending, (_state, _action) => ({
      ..._state,
      AncillaryKpiDataCommunityAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetAncillaryKpiDataCommunityAsync.rejected, (_state, _action) => ({
      ..._state,
      AncillaryKpiDataCommunityAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetAncillaryKpiDataCommunityAsync.fulfilled, (_state, action) => ({
      ..._state,
      AncillaryCommunity: action.payload,
      AncillaryKpiDataCommunityAsyncStatus: 'SUCCESS',
    }));

    // ########### COMPARISON ########### 
    builder.addCase(SetComparisonKpiDataCommunityAsync.pending, (_state, _action) => ({
      ..._state,
      ComparisonKpiDataCommunityAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetComparisonKpiDataCommunityAsync.rejected, (_state, _action) => ({
      ..._state,
      ComparisonKpiDataCommunityAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetComparisonKpiDataCommunityAsync.fulfilled, (_state, action) => ({
      ..._state,
      ComparisonCommunity: action.payload,
      ComparisonKpiDataCommunityAsyncStatus: 'SUCCESS',
    }));

    // ########### SITE DATA ########### 
    // ########### ENERGY ########### 
    builder.addCase(SetEnergyKpiDataSiteAsync.pending, (_state, _action) => ({
      ..._state,
      EnergyKpiDataSiteAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetEnergyKpiDataSiteAsync.rejected, (_state, _action) => ({
      ..._state,
      EnergyKpiDataSiteAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetEnergyKpiDataSiteAsync.fulfilled, (_state, action) => ({
      ..._state,
      EnergySite: action.payload as any,
      EnergyKpiDataSiteAsyncStatus: 'SUCCESS',
    }));

    builder.addCase(SetEnergyCustomKpiDataSiteAsync.pending, (_state, _action) => ({
      ..._state,
      EnergyCustomKpiDataSiteAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetEnergyCustomKpiDataSiteAsync.rejected, (_state, _action) => ({
      ..._state,
      EnergyCustomKpiDataSiteAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetEnergyCustomKpiDataSiteAsync.fulfilled, (_state, action) => ({
      ..._state,
      EnergyCustomKpiSite: action.payload as any,
      EnergyCustomKpiDataSiteAsyncStatus: 'SUCCESS',
    }));

    // ########### ECONOMICS ########### 
    builder.addCase(SetEconomicsKpiDataSiteAsync.pending, (_state, _action) => ({
      ..._state,
      EconomicsKpiDataSiteAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetEconomicsKpiDataSiteAsync.rejected, (_state, _action) => ({
      ..._state,
      EconomicsKpiDataSiteAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetEconomicsKpiDataSiteAsync.fulfilled, (_state, action) => ({
      ..._state,
      EconomicsSite: action.payload as any,
      EconomicsKpiDataSiteAsyncStatus: 'SUCCESS',
    }));

    builder.addCase(SetEconomicsCustomKpiDataSiteAsync.pending, (_state, _action) => ({
      ..._state,
      EconomicsCustomKpiDataSiteAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetEconomicsCustomKpiDataSiteAsync.rejected, (_state, _action) => ({
      ..._state,
      EconomicsCustomKpiDataSiteAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetEconomicsCustomKpiDataSiteAsync.fulfilled, (_state, action) => ({
      ..._state,
      EconomicsCustomKpiSite: action.payload as any,
      EconomicsCustomKpiDataSiteAsyncStatus: 'SUCCESS',
    }));

    // ########### ANCILLARY ########### 
    builder.addCase(SetAncillaryKpiDataSiteAsync.pending, (_state, _action) => ({
      ..._state,
      AncillaryKpiDataSiteAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetAncillaryKpiDataSiteAsync.rejected, (_state, _action) => ({
      ..._state,
      AncillaryKpiDataSiteAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetAncillaryKpiDataSiteAsync.fulfilled, (_state, action) => ({
      ..._state,
      AncillarySite: action.payload as any,
      AncillaryKpiDataSiteAsyncStatus: 'SUCCESS',
    }));

    // ########### MEMBER DATA ########### 
    // ########### ENERGY ########### 
    builder.addCase(SetEnergyKpiDataMemberAsync.pending, (_state, _action) => ({
      ..._state,
      EnergyKpiDataMemberAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetEnergyKpiDataMemberAsync.rejected, (_state, _action) => ({
      ..._state,
      EnergyKpiDataMemberAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetEnergyKpiDataMemberAsync.fulfilled, (_state, action) => ({
      ..._state,
      EnergyMember: action.payload as any,
      EnergyKpiDataMemberAsyncStatus: 'SUCCESS',
    }));

    builder.addCase(SetEnergyKpiDataMemberRankingAsync.pending, (_state, _action) => ({
      ..._state,
      EnergyKpiDataMemberRankingAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetEnergyKpiDataMemberRankingAsync.rejected, (_state, _action) => ({
      ..._state,
      EnergyKpiDataMemberRankingAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetEnergyKpiDataMemberRankingAsync.fulfilled, (_state, action) => ({
      ..._state,
      memberRanking: {
        ...(_state?.memberRanking || {}),
        ...action.payload,
      },
      EnergyKpiDataMemberRankingAsyncStatus: 'SUCCESS',
    }));

    builder.addCase(SetEnergyCustomKpiDataMemberAsync.pending, (_state, _action) => ({
      ..._state,
      EnergyCustomKpiDataMemberAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetEnergyCustomKpiDataMemberAsync.rejected, (_state, _action) => ({
      ..._state,
      EnergyCustomKpiDataMemberAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetEnergyCustomKpiDataMemberAsync.fulfilled, (_state, action) => ({
      ..._state,
      EnergyCustomKpiMember: action.payload as any,
      EnergyCustomKpiDataMemberAsyncStatus: 'SUCCESS',
    }));


    // ########### ECONOMICS ########### 
    builder.addCase(SetEconomicsKpiDataMemberAsync.pending, (_state, _action) => ({
      ..._state,
      EconomicsKpiDataMemberAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetEconomicsKpiDataMemberAsync.rejected, (_state, _action) => ({
      ..._state,
      EconomicsKpiDataMemberAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetEconomicsKpiDataMemberAsync.fulfilled, (_state, action) => ({
      ..._state,
      EconomicsMember: action.payload as any,
      EconomicsKpiDataMemberAsyncStatus: 'SUCCESS',
    }));

    builder.addCase(SetEconomicsCustomKpiDataMemberAsync.pending, (_state, _action) => ({
      ..._state,
      EconomicsCustomKpiDataMemberAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetEconomicsCustomKpiDataMemberAsync.rejected, (_state, _action) => ({
      ..._state,
      EconomicsCustomKpiDataMemberAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetEconomicsCustomKpiDataMemberAsync.fulfilled, (_state, action) => ({
      ..._state,
      EconomicsCustomKpiMember: action.payload as any,
      EconomicsCustomKpiDataMemberAsyncStatus: 'SUCCESS',
    }));


    builder.addCase(SetEconomicsKpiDataMemberRankingAsync.pending, (_state, _action) => ({
      ..._state,
      EconomicsKpiDataMemberRankingAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetEconomicsKpiDataMemberRankingAsync.rejected, (_state, _action) => ({
      ..._state,
      EconomicsKpiDataMemberRankingAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetEconomicsKpiDataMemberRankingAsync.fulfilled, (_state, action) => ({
      ..._state,
      memberRanking: {
        ...(_state?.memberRanking || {}),
        ...action.payload,
      },
      EconomicsKpiDataMemberRankingAsyncStatus: 'SUCCESS',
    }));



    // ########### ANCILLARY ########### 
    builder.addCase(SetAncillaryKpiDataMemberAsync.pending, (_state, _action) => ({
      ..._state,
      AncillaryKpiDataMemberAsyncStatus: 'PENDING',
    }));
    builder.addCase(SetAncillaryKpiDataMemberAsync.rejected, (_state, _action) => ({
      ..._state,
      AncillaryKpiDataMemberAsyncStatus: 'ERROR',
    }));
    builder.addCase(SetAncillaryKpiDataMemberAsync.fulfilled, (_state, action) => ({
      ..._state,
      AncillaryMember: action.payload as any,
      AncillaryKpiDataMemberAsyncStatus: 'SUCCESS',
    }));
  },
});

// Action creators are generated for each case reducer function
export const {
  SetKpiDataSite,
  SetKpiDataCommunity,
  SetKpiDataCommunityRanking,
  SetKpiDataMemberRanking,
  SetKpiDataCustom,
  ResetKpiApiStore,
  SetKpiDataMember,
  SetLoading,
  ResetKpiFields,
  ResetNamedKpiFields,
  SetKwickInvoices,
} = KPIslice.actions;

export {
  SetEnergyKpiDataCommunityAsync,
  SetEconomicsKpiDataCommunityAsync,
  SetEnergyKpiDataCommunityRankingAsync,
  SetEconomicsKpiDataCommunityRankingAsync,
  SetEnergyKpiDataSiteAsync,
  SetEconomicsKpiDataSiteAsync,
  SetEnergyKpiDataMemberAsync,
  SetEconomicsKpiDataMemberAsync,
  SetEnergyKpiDataMemberRankingAsync,
  SetEconomicsKpiDataMemberRankingAsync,
  SetAncillaryKpiDataSiteAsync,
  SetAncillaryKpiDataMemberAsync,
  SetAncillaryKpiDataCommunityAsync,
  SetComparisonKpiDataCommunityAsync,
  SetEconomicsCustomKpiDataMemberAsync,
  SetEnergyCustomKpiDataMemberAsync,
  SetEnergyCustomKpiDataCommunityAsync,
  SetEconomicsCustomKpiDataCommunityAsync,
  SetEconomicsCustomKpiDataSiteAsync,
  SetEnergyCustomKpiDataSiteAsync,
};

export default KPIslice.reducer;
